import React from "react";
import { Box, Divider, Label, Typography } from "@bca/ui-library";
import styled from "styled-components";

import PricingAndVATProps from "./PricingAndVAT.type";
import media from "../media";
import { formatPrice } from "./PricingAndVAT";
import { SaleChannelTags } from "./constants";
import HPISpecCheckDesktop from "./HPISpecCheckDesktop";

const PricingBox = styled(Box)`
  display: none;
  ${media.desktop} {
    display: flex;
  }
`;

const PricingAndVATDesktop: React.FunctionComponent<PricingAndVATProps> = ({
  saleChannel,
  saleChannelTags,
  buyNowPrice,
  capClean,
  vatType,
  currentBid,
  hpi,
  HPISpecCheckLink,
  vehicleAnalytics,
}) => {
  const vat = vatType?.split(" ")[0];
  const type = vatType?.split(" ")[1];

  const buyNow = Number(buyNowPrice?.replace("£", ""));

  const isOnlineAuctionSaleChannel = saleChannelTags?.some(
    (tag: string) => tag === SaleChannelTags.ONLINE_AUCTION
  );

  const isBidNowSaleChannel = saleChannelTags?.some(
    (tag: string) => tag === SaleChannelTags.BID_NOW
  );

  const isBuyNowSaleChannel = saleChannelTags?.some(
    (tag: string) => tag === SaleChannelTags.BUY_NOW
  );

  const isHybridSaleChannel = saleChannelTags?.some(
    (tag: string) => tag === SaleChannelTags.HYBRID
  );

  return (
    <PricingBox
      display="flex"
      flexDirection="column"
      height="100%"
      justifyContent="space-between"
    >
      <Box
        display="flex"
        flexDirection="column"
        css={`
          gap: 12px;
        `}
      >
        {isOnlineAuctionSaleChannel && (
          <Box display="flex">
            <Label
              backgroundColor="grey-blue"
              label={SaleChannelTags.ONLINE_AUCTION}
              height="24px"
            />
          </Box>
        )}

        {isHybridSaleChannel && (
          <Box display="flex">
            <Label
              backgroundColor="grey-blue"
              label={SaleChannelTags.HYBRID}
              height="24px"
            />
          </Box>
        )}

        {isBidNowSaleChannel && (
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Label
              backgroundColor="grey-blue"
              label={SaleChannelTags.BID_NOW}
              height="24px"
            />
            {saleChannel === "Tender" && Boolean(currentBid) && (
              <Typography variant="body-small" color="primary-navy-blue" m={0}>
                {formatPrice(currentBid)}
              </Typography>
            )}
          </Box>
        )}
        {isBuyNowSaleChannel && (
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Label
              backgroundColor="grey-blue"
              label={SaleChannelTags.BUY_NOW}
              height="24px"
            />
            {saleChannel !== "InternetAuction" && Boolean(buyNowPrice) && (
              <Typography variant="h6" mb={0} mt={0} color="primary-navy-blue">
                {formatPrice(buyNow)}
              </Typography>
            )}
          </Box>
        )}
      </Box>
      <Divider
        width="160px"
        css={`
          background-color: #c9ccd2;
          opacity: 50%;
        `}
      />
      <Box
        display="flex"
        flexDirection="column"
        css={`
          gap: 12px;
        `}
      >
        {Boolean(hpi) && (
          <Box
            display="flex"
            flexDirection="row"
            justifyContent="space-between"
          >
            <HPISpecCheckDesktop
              starRating={hpi.optionsRating}
              price={hpi.optionsPrice}
              anchorLink={HPISpecCheckLink}
              vehicleAnalytics={vehicleAnalytics}
            />
          </Box>
        )}
        <Box display="flex" justifyContent="space-between">
          <Typography
            variant="body-small"
            fontWeight="medium"
            color="secondary-darkest-grey"
            my={0}
          >
            {Boolean(capClean) ? "CAP Clean" : ""}
          </Typography>
          <Typography variant="body-small" color="primary-navy-blue" my={0}>
            {capClean}
          </Typography>
        </Box>
        <Box display="flex" justifyContent="space-between">
          <Typography
            variant="body-small"
            fontWeight="medium"
            color="secondary-darkest-grey"
            my={0}
          >
            {vat}
          </Typography>
          <Typography variant="body-small" my={0} color="primary-navy-blue">
            {type}
          </Typography>
        </Box>
      </Box>
    </PricingBox>
  );
};

export default PricingAndVATDesktop;
